<div class="display-table login-wrap rstlogin-wrap">
  <div class="looginfx">
        <img src="assets/img/blur1.jpg">
  </div>
  <div class="display-cell">
     <div class="container">
        <div class="logincard rstlogincard">
           <div class="row">
              <div class="col-sm-12">
                 <form [formGroup] = "resetPassForm" (ngSubmit)="onSubmit(resetPassForm)">
                 <mat-card>
                     <mat-card-title>
                       Reset Password
                    </mat-card-title>
                    <mat-card-content>
                       <!-- Password -->
                       <div class="row">
                        <div class="col-sm-12">
                           <mat-form-field class="example-full-width">
                              <input type="password" matInput placeholder="New Password" formControlName="Password">
                              <mat-error *ngIf="!f.Password.valid && f.Password.touched && (f.Password.pristine || f.Password.dirty) && (!f.Password.hasError('minlength'))">
                                 <strong>Required</strong>
                              </mat-error>
                              <mat-error *ngIf="(f.Password.hasError('minlength'))
                                           && (f.Password.pristine || f.Password.dirty)">
                                           Min length should be 6
                              </mat-error>

                           </mat-form-field>
                        </div>
                        <!-- ConfirmPassword -->
                        <div class="col-sm-12">
                           <mat-form-field class="example-full-width">
                              <input type="password" matInput placeholder="Confirm Password" formControlName="ConfirmPassword">
                                  <mat-error *ngIf="f.ConfirmPassword.valid && f.ConfirmPassword.touched && (f.ConfirmPassword.pristine || f.ConfirmPassword.dirty) && (!f.ConfirmPassword.hasError('minlength'))">
                                    <strong>Required</strong>
                                  </mat-error>
                                  <mat-error *ngIf="f.ConfirmPassword.hasError('MatchPassword') && f.ConfirmPassword.touched">
                                      Password does not match
                                  </mat-error>
                           </mat-form-field>
                        </div>
                     </div>
                       <div class="btn-blk">
                          <button mat-raised-button [disabled]="resetPassForm.invalid">Submit</button>
                       </div>
                    </mat-card-content>
                 </mat-card>
                 </form>
              </div>
           </div>
        </div>
     </div>
  </div>
</div>
